var e4 = e4 || {};
( function () {
    'use strict';
    var jHTML = jQuery( 'html' );
    e4.settings = {
        lang: ( function () {
            return jHTML.attr( 'lang' );
        }() ),
        intergerSeparator: ( function () {
            return jHTML.data( 'integer-separator' );
        }() ),
        decimalSeparator: ( function () {
            return jHTML.data( 'decimal-separator' );
        }() ),
        animation: {
            speed: 375
        },
        navigation: {
            autoHideTolerance: {
                up: 25,
                down: 'auto'
            },
            revealActive: {
                delay: 400,
                speed: 0.75,
                easing: 'swing'
            }
        },
        parallax: {
            speed: -0.35
        },
        scrollReveal: {
            selector: '.js-e-scroll-reveal .e-section',
            classAnimateInOnLoad: 'animate-in-on-load',
            classAnimateInOnScroll: 'animate-in-on-scroll',
            classResetAnimate: 'reset-animate'
        },
        scrollToAnchor: {
            speed: 0.5,
            nudge: 2,
            easing: 'swing',
            stickyElements: '.js-e-header',
            fullscreenElements: '.p-section-fullscreen, .p-banner-fullscreen',
            backToTop: {
                revealOffset: 1.5
            }
        },
        forms: {
            validate: {
                messages: {}
            }
        },
        search: {
            delay: {
                min: 100,
                max: 1000
            },
            result: {
                pages: {
                    show: true,
                    url: '/system/data/search?q='
                },
                products: {
                    show: true,
                    url: '/system/data/products?q=',
                    showAllLink: '/shop/search?q=',
                    max: {
                        xs: 2,
                        sm: 3,
                        md: 4,
                        lg: 5,
                        xl: 5
                    }
                }
            }
        },
        require: {
            jQueryValidate: {
                test: 'window.jQuery.fn.validate',
                url: '//cdnjs.cloudflare.com/ajax/libs/jquery-validate/1.16.0/jquery.validate.min.js',
                fallback: '/files/system/espresso/design/js/vendor/jquery.validate.min.js',
                callback: null
            },
            handlebars: {
                test: 'window.Handlebars',
                url: '//cdnjs.cloudflare.com/ajax/libs/handlebars.js/4.0.5/handlebars.min.js',
                fallback: '/files/system/espresso/design/js/vendor/handlebars-v4.0.5.min.js',
                callback: null
            },
            MarkerClusterer: {
                test: 'window.MarkerClusterer',
                url: '//cdnjs.cloudflare.com/ajax/libs/js-marker-clusterer/1.0.0/markerclusterer.js', //_compiled
                fallback: '/files/system/espresso/design/js/vendor/markerclusterer_compiled.js',
                callback: null
            },
            jQueryUImap: {
                test: 'window.jQuery.fn.gmap',
                url: '//cdnjs.cloudflare.com/ajax/libs/jquery-ui-map/3.0-rc1/min/jquery.ui.map.min.js',
                fallback: '/files/system/espresso/design/js/vendor/jquery.ui.map.min.js',
                callback: null
            },
            typeahead: {
                test: 'window.jQuery.fn.typeahead',
                url: '//cdnjs.cloudflare.com/ajax/libs/corejs-typeahead/1.1.1/typeahead.jquery.min.js',
                fallback: '/files/system/espresso/design/js/vendor/typeahead.jquery.min.js',
                callback: null
            },
            places: {
                test: 'window.places',
                url: '//cdn.jsdelivr.net/places.js/1/places.min.js',
                fallback: '/files/system/espresso/design/js/vendor/places-v1.4.12.min.js',
                callback: null
            }
        },
        ecom: {
            cart: {
                url: '/system/data/cart',
                msgHideDelay: 10000
            },
            checkout: {
                url: '/system/data/checkout',
                delay: 500,
                multipageBreakpoint: 'lg',
                shipping: {
                    glsID: 'SHIP2',
                    pacsoftID: 'SHIP5'
                },
                termsAndConditions: '/shop/terms-and-conditions'
            }
        },
        breakpoint: {
            xs: 0,
            sm: 544,
            md: 768,
            lg: 922,
            xl: 1200
        },
        collapse: {
            peekSizeMin: 1.5
        },
        dealersearch: {
            showListOnLoad: true,
            zoom: {
                min: 12,
                max: 15,
                initial: 6
            },
            results: {
                min: 2,
                sensitivity: 0.5
            },
            country: {
                DK: {
                    center: {
                        lat: 56.26392,
                        lng: 9.501785
                    },
                    zoom: 7
                },
                NO: {
                    center: {
                        lat: 64.8748158,
                        lng: 12.571043
                    },
                    zoom: 5
                },
                SE: {
                    center: {
                        lat: 60.12816100000001,
                        lng: 18.643501
                    },
                    zoom: 5
                },
                DE: {
                    center: {
                        lat: 51.165691,
                        lng: 10.451526
                    },
                    zoom: 6
                },
                NL: {
                    center: {
                        lat: 52.2951187,
                        lng: 5.8120334
                    },
                    zoom: 7
                },
                GB: {
                    center: {
                        lat: 54.428805,
                        lng: -3.9084492
                    },
                    zoom: 6
                }
            }
        }
    };
}() );
